import { projectStyles } from 'global/styles/projectStyles'
import React, { useCallback, useContext } from 'react'
import { ParentContext } from '../ParentContext'
import { getSectionClass } from 'global/styles/formatting'

export const useStyles = () => {

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {})
  const { formatting, projectOptions } = aps_global ?? {}

  const setStyleAndClass = useCallback(({ item, opts, ignoreColors, forActive, forLine }) => {

    const { themedItems, themeColors } = aps_global ? aps_global : {}
    const { defaultTheme } = themedItems ?? {}

    let defaultCnS = opts ? { style: {} } : projectStyles()[item]

    if (!defaultCnS) { defaultCnS = { style: {} } }
    if (!defaultCnS.style) { defaultCnS.style = {} }

    if (themedItems && item && themedItems[item]) {

      const themeItem = themedItems[item]

      defaultCnS.className = getSectionClass(defaultCnS.className, themeItem)

      if (themeItem && !ignoreColors && themeColors) {

        const { borderColor, colors, activeColors, lineColor, backgroundImage } = themeItem

        if (borderColor && borderColor.color && borderColor.color && themeColors[borderColor.color]) {
          defaultCnS.style.borderColor = themeColors[borderColor.color]
        }

        if (backgroundImage) {
          defaultCnS.style.bgi = backgroundImage
        }

        if (forActive) {
          if (activeColors && activeColors.apply) {
            const { apply, backgroundColor, color: foreColor } = activeColors ? activeColors : {}
            if (apply) {
              if (backgroundColor) {
                if (themeColors[backgroundColor]) {
                  defaultCnS.style.backgroundColor = themeColors[backgroundColor]
                }
              }
              switch (item) {
                // case 'background':
                //   break;
                default:
                  if (foreColor) {
                    if (themeColors[foreColor]) {
                      defaultCnS.style.color = themeColors[foreColor]
                    }
                  }
              }
              removeClass(defaultCnS)
            }
          }
        } else if (forLine) {
          if (lineColor && lineColor.apply) {
            const { apply, color: foreColor } = lineColor ? lineColor : {}
            if (apply) {
              defaultCnS.style.borderColor = themeColors[foreColor]
              removeClass(defaultCnS)
            }
          } else {
            setDefaultStyle(item, defaultTheme, themeColors, defaultCnS)
          }
        } else if (colors && colors.apply) {
          const { apply, backgroundColor, color: foreColor } = colors ? colors : {}
          if (apply) {
            if (backgroundColor) {
              if (themeColors[backgroundColor]) {
                defaultCnS.style.backgroundColor = themeColors[backgroundColor]
              }
            }
            switch (item) {
              // case 'background':
              //   break;
              default:
                if (foreColor) {
                  if (themeColors[foreColor]) {
                    defaultCnS.style.color = themeColors[foreColor]
                  }
                }
            }
            removeClass(defaultCnS)
          }
        } else {
          setDefaultStyle(item, defaultTheme, themeColors, defaultCnS)
        }
      }
    }

    return defaultCnS
  }, [])

  return { setStyleAndClass }
}

const setDefaultStyle = (item, defaultTheme, themeColors, defaultCnS) => {
  const { colors } = defaultTheme ? defaultTheme : {}
  const { apply, backgroundColor, color } = colors ? colors : {}
  if (apply) {
    switch (item) {
      case 'active':
      case 'background':
      case 'content':
      case 'headers':
        break;
      default:
        if (colors) {
          if (backgroundColor && themeColors[backgroundColor]) { defaultCnS.style.backgroundColor = themeColors[backgroundColor] }
          if (color && themeColors[color]) { defaultCnS.style.color = themeColors[color] }
          removeClass(defaultCnS)
        }
    }
  }
}


const removeClass = (themeProps) => {
  if (themeProps.className) {
    themeProps.className = themeProps.className.replace('bc-main', '')
    themeProps.className = themeProps.className.replace('bc-bk', '')
    themeProps.className = themeProps.className.replace('bc-sec', '')
    themeProps.className = themeProps.className.replace('bc-settings', '')
  }
}
